module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av734-866bf32c1db030f5389911b5c9ec67f2.jpg";